import { render } from "./EnIconUser.vue?vue&type=template&id=2f2883b4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/icons/navigation/EnIconUser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f2883b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f2883b4', __exports__)) {
    api.reload('2f2883b4', __exports__)
  }
  
  module.hot.accept("./EnIconUser.vue?vue&type=template&id=2f2883b4", () => {
    api.rerender('2f2883b4', render)
  })

}


export default __exports__